<template>
  <section class="section scEditProfile" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
          <h4>Edit profil</h4>
        </div>
        <div class="contentSc">
          <div class="profilePict" v-if="avatar" id="pickAvatar"
            :class="{uploading: uploadingAvatar}"
            :style="{'background-image': `url(${avatar})`}">
            <div class="editAvatar"></div>
          </div>
          <div class="profilePict" id="pickAvatar"
            :class="{uploading: uploadingAvatar}"
            v-else><div class="noImg"></div></div>
          <div class="menuCnt loading" v-if="loading">
            <div class="menuItem loading"></div>
          </div>
          <div class="menuCnt" v-else-if="user">
            <div class="menuItem" v-on:click="editUser('name', 'Nama')">
              <div class="menuIcon about"></div>
              Nama
              <span v-if="user.name">{{user.name}}</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="editUser('about', 'Tentang')">
              <div class="menuIcon about"></div>
              Tentang
              <span v-if="user.about">{{user.about}}</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="$router.push('/body-composition?tab=birthdate')">
              <div class="menuIcon settings"></div>
              Tanggal Lahir
              <span v-if="user.birthdate">{{user.birthdate | moment("ddd, D MMM YYYY")}}</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="$router.push('/character/choose?update=y')">
              <div class="menuIcon about"></div>
              Karakter
              <span v-if="user.character === 'nunu'">Nunu</span>
              <span v-else>Lili</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="$router.push('/body-composition?tab=gender')">
              <div class="menuIcon about"></div>
              Jenis Kelamin
              <span v-if="user.gender === 'male'">Laki-laki</span>
              <span v-else>Perempuan</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="$router.push('/t-shirt/size?edit=y')">
              <div class="menuIcon about"></div>
              Ukuran Kaos
              <span v-if="user.tshirtSize">{{user.tshirtSize}}</span>
              <span v-else>Tidak Diketahui</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="$router.push('/t-shirt/size?address=y')">
              <div class="menuIcon about"></div>
              Alamat
              <span v-if="user.address">{{user.address.address.substr(0, 16)}}...</span>
              <span v-else>Tidak Diketahui</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="$router.push('/body-composition?tab=bmi')">
              <div class="menuIcon about"></div>
              BMI
              <span v-if="user.bmi">{{user.bmi.toLocaleString('id')}}</span>
              <span v-else>-</span>
              <div class="bmiType" v-if="user.bmi < 17">
                Kekurangan berat badan tingkat berat
              </div>
              <div class="bmiType" v-else-if="user.bmi < 18.5">
                Kekurangan berat badan tingkat ringan
              </div>
              <div class="bmiType" v-else-if="user.bmi < 25.1">
                Normal
              </div>
              <div class="bmiType" v-else-if="user.bmi < 27">
                Kelebihan berat badan tingkat ringan
              </div>
              <div class="bmiType" v-else>
                Kelebihan berat badan tingkat berat
              </div>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="$router.push('/body-composition?tab=bmr')">
              <div class="menuIcon about"></div>
              BMR
              <span v-if="user.bmr">{{user.bmr.toLocaleString('id')}} kalori</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="$router.push('/body-composition?tab=bmr')">
              <div class="menuIcon about"></div>
              Tipe TDEE
              <span v-if="user.tdeeType">{{user.tdeeType}}</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
            <div class="menuItem last" v-on:click="$router.push('/body-composition?tab=bmr')">
              <div class="menuIcon about"></div>
              TDEE
              <span v-if="user.tdee">{{user.tdee}} kalori</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
          </div>
          <div class="aboNo">
            ABO No. {{aboNo}}
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <AvatarCropper v-on:uploading="uploading" v-on:uploaded="uploaded"
      trigger="#pickAvatar" :upload-url="uploadUrl"
      :output-options="{width: 600, height: 600}"
      :upload-headers="uploadHeaders"
      :labels="{submit: 'Save Avatar', cancel: 'Cancel'}"/>
    <MediaInputer ref="mediaInputer"/>
    <Snackbar ref="snackbar"/>
  </section>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';
import Confirmation from '@/components/Confirmation.vue';
import MediaInputer from '@/components/MediaInputer.vue';
import Snackbar from '@/components/Snackbar.vue';

import config from '../config';

export default {
  name: 'home',
  components: {
    Confirmation,
    AvatarCropper,
    MediaInputer,
    Snackbar,
  },
  data() {
    return {
      aboNo: '. . .',
      user: null,
      avatar: null,
      loading: true,
      uploadingAvatar: false,
      uploadUrl: '',
      uploadHeaders: {},
      show: false,
    };
  },
  methods: {
    doNothing() {},
    open() {
      this.show = true;
      this.loading = true;
      this.getData();
    },
    close() { this.show = false; },
    uploading() {
      this.avatar = null;
      this.uploadingAvatar = true;
    },
    uploaded(response) {
      this.uploadingAvatar = false;
      this.avatar = response.avatar;
      this.$session.set('bk6_avatar', this.avatar);
    },
    getData() {
      this.avatar = this.$session.get('bk6_avatar');
      this.uploadUrl = this.$config.uri('user/avatar');
      this.uploadHeaders = {
        Key: config.apiKey,
        Authoziration: this.$session.get('bk6_jwt'),
      };
      this.$http.get(this.$config.uri('user/abo/number')).then((r) => {
        this.aboNo = (r.data.status === 200) ? r.data.data : 'Unknown';
      });
      this.$http.get(this.$config.uri('user/detail')).then((r) => {
        this.loading = false;
        this.user = (r.data.status === 200) ? r.data.data : null;
      });
    },
    editUser(field, title) {
      const type = (field === 'about') ? 'text' : 'input';
      this.$refs.mediaInputer.open({
        title,
        placeholder: title,
        type,
        action: 'Simpan',
        model: this.user[field],
      }, (b, v) => {
        if (!b) return;
        this.user[field] = v;
        if (field === 'name') this.$session.set('bk6_name', v);
        this.$http.post(this.$config.uri('user/profile/update'), {
          name: this.user.name,
          about: this.user.about,
        }).then((r) => {
          this.$refs.snackbar.open({ content: 'Profile updated' });
        });
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
  .avatar-cropper-overlay{
    .avatar-cropper-mark{
      background-color: rgba(0,0,0,.6);
      backdrop-filter: saturate(180%) blur(20px);
    }
    .avatar-cropper-container{
      padding: 40px 80px;
      border-radius: 5px;
      @media (max-width: 960px) {
        padding: 20px 0;
        margin: 0 10px;
      }
    }
    .avatar-cropper-footer{
      margin: 20px -80px -40px;
      border-top: #eee 1px solid;
      padding: 12px 30px;
      display: block !important;
      text-align: right;
      @media (max-width: 960px) {
        padding: 12px 20px;
        margin: 20px 0 -20px;
      }
      button{
        margin-left: 10px;
        background-color: #78C90E !important;
        width: auto !important;
        color: #fff;
        padding: 10px 20px !important;
        border-radius: 4px;
        font-weight: bold;
        font-size: 18px;
        outline: 0 !important;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #006519 !important;
        }
        &:first-child{
          background-color: #fff !important;
          color: #78C90E !important;
          &:hover{
            background-color: #fff !important;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
.section.scEditProfile{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;
    background-color: #e6e1c1;

    background-color: #b7e4c9;
    background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    padding: 0 0 40px;
    box-sizing: border-box;
    width: 400px;
    z-index: 3;
    right: -400px;
    transition: all .45s ease;
    @media (max-width: 768px) {
      top: 60px;
    }
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 5px 20px;
    z-index: 7;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 18px;
      margin: 0;
      color: #444;
      position: absolute;
      left: 80px; top: 13px; right: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 70px 10px 10px;
  }
  .profilePict{
    width: 200px; height: 200px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 0 auto 16px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, .2);
    font-size: 32px;
    color: #fff;
    font-weight: 600;
    position: relative;
    cursor: pointer;
    .editAvatar{
      width: 46px; height: 46px;
      background-color: #fff;
      border-radius: 50%;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
      position: absolute;
      right: 4px; top: 4px;
      background-image: url(../assets/edit-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: background-color .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    .noImg{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 2px;
      background-image: url(../assets/camera.png);
      background-size: 86px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .3;
    }
    &.uploading{
      background-image: url(../assets/loading.svg) !important;
      background-size: 84px auto !important;
      .noImg{
        display: none;
      }
    }
  }
  .profileInfo{
    text-align: center;
    padding-bottom: 20px;
    h4{
      margin: 0;
      font-size: 20px;
    }
    p{
      margin: 0;
      font-size: 15px;
    }
  }
  .expCnt{
    background-color: rgba(255, 255, 255, .5);
    margin: 0 10px 10px;
    border-radius: 10px;
    padding: 16px 20px 20px;
    position: relative;
    &:active{
      background-color: #ddd;
    }
    h4{
      margin: 0 0 6px;
      font-size: 16px;
    }
    .expLabel{
      position: absolute;
      right: 20px; top: 18px;
      font-size: 14px;
    }
    .theExp{
      height: 12px;
      background-color: #ccc;
      border-radius: 50px;
      .exp{
        height: 100%;
        background-color: #8EC642;
        // background-color: #6aa722;
        border-radius: 50px;
        max-width: 100%;
      }
    }
  }
  .progressCnt{
    background-color: rgba(255, 255, 255, .5);
    margin: 0 10px;
    border-radius: 10px;
    padding: 16px 20px 52px;
    h4{
      margin: 0 0 10px;
    }
    .theProgress{
      display: flex;
      height: 80px;
      justify-content: space-between;
      .progressItem{
        height: 100%;
        font-size: 10px;
        text-align: center;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: relative;
        .label{
          position: absolute;
          left: 50%; margin-left: -15px;
          text-align: center;
          bottom: -34px;
          width: 30px;
          span{
            display: block;
            font-size: 14px;
            font-weight: bold;
            margin-top: -1px;
          }
        }
        .progress{
          width: 8px;
          background-color: #8EC642;
          background-color: #6aa722;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
    }
  }
  .aboNo{
    margin: 10px 20px 20px;
    font-size: 13px;
    color: #767676;
  }
  .menuCnt{
    // padding: 20px 0 40px;
    margin: 30px 0 60px;
    background-color: rgba(255, 255, 255, .5);
    position: relative;
    overflow: hidden;
    margin-bottom: -1px;
    @media (min-height: 680px) {
      margin-left: 10px;
      margin-right: 10px;
      border-radius: 10px;
    }
    &.loading{
      padding-top: 20px;
      background-color: transparent;
    }
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 16px 20px;
      padding-right: 56px;
      font-weight: bold;
      color: #444;
      position: relative;
      margin: 0;
      font-size: 17px;
      transition: all .3s ease;
      cursor: pointer;
      background-color: rgba(255, 255, 255, .5);
      backdrop-filter: blur(20px);
      &:hover{
        background-color: rgba(255, 255, 255, .8);
      }
      &:before{
        position: absolute;
        content: "";
        height: 1px;
        left: 20px; right: 0; bottom: 0;
        background-color: #e5e5e5;
      }
      @media (min-height: 680px) {
        &.last:before{
          display: none;
        }
      }
      .bmiType{
        text-align: right;
        font-size: 15px;
        font-weight: normal;
      }
      span{
        font-weight: normal;
        float: right;
      }
      &.loading{
        height: 54px;
        box-sizing: border-box;
        margin: 0;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 46px auto;
        border: none;
        &:before{
          display: none;
        }
      }
      &:active{
        background-color: #ddd;
      }
      .more{
        position: absolute;
        right: 20px; top: 16px;
        width: 20px; height: 20px;
        background-position: center;
        background-size: 20px auto;
        background-repeat: no-repeat;
        background-image: url(../assets/edit-black.png);
      }
      &.logout{
        color: #fe3126;
      }
      .menuIcon{
        position: absolute;
        left: 20px; top: 16px;
        width: 20px; height: 20px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        opacity: .9;
        display: none;
        &.about{
          background-image: url(../assets/account.png);
        }
        &.settings{
          background-image: url(../assets/setting.png);
        }
        &.gallery{
          background-image: url(../assets/image-gallery.png);
        }
        &.link{
          background-image: url(../assets/foreign.png);
        }
        &.logout{
          background-image: url(../assets/logout-red.png);
        }
      }
    }
  }
}
</style>
